import React from 'react';
import DisplayHelper from './DisplayHelper';
import { iEnergipresentationGraphViewerModel } from './GraphViewer';
import iTextReplacements from './iTextReplacements';

interface EnergipresentationOpenInNewTabButtonProps {
    id: string;
    data: any;
    title: string;
    viewType: string; // 'sankey' | 'pie' | 'area' | 'spline' | 'column' | 'scale'
    textReplacements: iTextReplacements;
    columnHeaders: string;
    invertTableAxis: boolean;
    helpTitle?: string;
    helpText?: string;
    table?: string;
    modelStyle?: string;
}

const EnergipresentationOpenInNewTabButton = (props: EnergipresentationOpenInNewTabButtonProps) => {

    const handleClick = () => {
        const win = window.open('/graph-viewer/', '_blank');

        const messageHandler = (event: MessageEvent) => {
            if (event.source === win && event.data === "READY_FOR_DATA") {
                win?.postMessage(
                    {
                        Id: props.id,
                        Type: 'VIEWER_DATA',
                        Payload: props.data,
                        ViewType: props.viewType,
                        Title: props.title,
                        TextReplacements: props.textReplacements,
                        ColumnHeaders: props.columnHeaders,
                        InvertTableAxis: props.invertTableAxis,
                        AccordionTitle: props.helpTitle,
                        AccordionText: props.helpText,
                        AccordionTable: props.table,
                        AccordionStyle: props.modelStyle
                    } as iEnergipresentationGraphViewerModel,
                    window.location.origin,
                );
                window.removeEventListener("message", messageHandler);
            }
        };

        window.addEventListener("message", messageHandler);
    };

    const buttonText = (): string => {
        return DisplayHelper.LocaleText('Open in new tab', 'Öppna i ny flik');
    };

    return (
        <button className="btn btn-external" onClick={handleClick}>
            {buttonText()}
        </button>
    );
};

export default EnergipresentationOpenInNewTabButton;
